'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var angular = require('angular');

var datePickerComponent = exports.datePickerComponent = function () {

  /*@ngInject*/
  function datePickerComponent() {
    _classCallCheck(this, datePickerComponent);

    this.dateOptions = {
      minDate: new Date(),
      format: 'shortDate'
    };
    this.popup = {};
    this.format = 'shortDate';

    this.message = 'World';

    this.inputName = 'test';
    this.inputRequired = false;
    this.inputDisabled = false;
    this.dateOptions.minDate = this.minDate || null;
  }

  _createClass(datePickerComponent, [{
    key: 'clear',
    value: function clear() {
      this.dt = null;
    }
  }, {
    key: 'open',
    value: function open() {
      this.dateOptions.minDate = this.minDate || null;
      this.popup.opened = true;
      console.log(this.inputDisabled);
    }
  }]);

  return datePickerComponent;
}();

exports.default = angular.module('fiapiApp.datePicker', []).component('datePicker', {
  template: require('./datePicker.pug'),
  bindings: { dt: '=', change: '=', minDate: '<', inputSize: '@', inputRequired: '@', inputDisabled: '@', inputName: '@' },
  controller: datePickerComponent
}).name;


// WEBPACK FOOTER //
// ./client/components/datePicker/datePicker.component.js